import type { MetersModule } from '@/types/organization'
import type {
	ActionsMetricsResponse,
	ApiKeysMetricsResponse,
	CombinedOrgMetricsResponse,
	DbcMetricsResponse,
	GeneralMetricsResponse,
	SessionsMetricsResponse,
	StreamsMetricsResponse,
} from '@/types/organization-owner-api'
import { ownerApiCall } from './axiosInstance'
import { fetchOrganizationMeters } from './organizationMetricsMappers'

export const organizationMetricsApi = {
	getAllMetrics: async (organizationId: string): Promise<CombinedOrgMetricsResponse> => {
		return ownerApiCall<CombinedOrgMetricsResponse>(`/v3/organizations/${encodeURIComponent(organizationId)}/metrics`)
	},
	getDevicesMeters: async (organizationId: string): Promise<GeneralMetricsResponse> => {
		return ownerApiCall<GeneralMetricsResponse>(
			`/v3/organizations/${encodeURIComponent(organizationId)}/metrics/devices`,
		)
	},
	getDashboardsMeters: async (organizationId: string): Promise<GeneralMetricsResponse> => {
		return ownerApiCall<GeneralMetricsResponse>(
			`/v3/organizations/${encodeURIComponent(organizationId)}/metrics/dashboards`,
		)
	},
	getActionsMeters: async (organizationId: string): Promise<ActionsMetricsResponse> => {
		return ownerApiCall<ActionsMetricsResponse>(
			`/v3/organizations/${encodeURIComponent(organizationId)}/metrics/actions`,
		)
	},
	getSessionsMeters: async (organizationId: string): Promise<SessionsMetricsResponse> => {
		return ownerApiCall<SessionsMetricsResponse>(
			`/v3/organizations/${encodeURIComponent(organizationId)}/metrics/sessions`,
		)
	},
	getDbcMeters: async (organizationId: string): Promise<DbcMetricsResponse> => {
		return ownerApiCall<DbcMetricsResponse>(`/v3/organizations/${encodeURIComponent(organizationId)}/metrics/dbc`)
	},
	getExportersMeters: async (organizationId: string): Promise<GeneralMetricsResponse> => {
		return ownerApiCall<GeneralMetricsResponse>(
			`/v3/organizations/${encodeURIComponent(organizationId)}/metrics/exporters`,
		)
	},
	getStreamsMeters: async (organizationId: string): Promise<StreamsMetricsResponse> => {
		return ownerApiCall<StreamsMetricsResponse>(
			`/v3/organizations/${encodeURIComponent(organizationId)}/metrics/streams`,
		)
	},
	getUsersMeters: async (organizationId: string): Promise<GeneralMetricsResponse> => {
		return ownerApiCall<GeneralMetricsResponse>(`/v3/organizations/${encodeURIComponent(organizationId)}/metrics/users`)
	},
	getRolesMeters: async (organizationId: string): Promise<GeneralMetricsResponse> => {
		return ownerApiCall<GeneralMetricsResponse>(`/v3/organizations/${encodeURIComponent(organizationId)}/metrics/roles`)
	},
	getMetadataMeters: async (organizationId: string): Promise<GeneralMetricsResponse> => {
		return ownerApiCall<GeneralMetricsResponse>(
			`/v3/organizations/${encodeURIComponent(organizationId)}/metrics/metadata`,
		)
	},
	getApiKeysMeters: async (organizationId: string): Promise<ApiKeysMetricsResponse> => {
		return ownerApiCall<ApiKeysMetricsResponse>(
			`/v3/organizations/${encodeURIComponent(organizationId)}/metrics/apikeys`,
		)
	},
	getMeters: (organizationId: string, module: MetersModule) =>
		fetchOrganizationMeters(organizationMetricsApi, organizationId, module),
}
